import _slicedToArray from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { arc, line } from 'd3-shape';
import { isPolar } from '../../utils/coordinate';
import { select } from '../../utils/selection';
import { dist } from '../../utils/vector';
import { subObject } from '../../utils/helper';
import { applyStyle } from '../utils';
function getArrowMarker(document, arrowSize, arrowStyle) {
  var arrowMarker = document.createElement('path', {
    style: Object.assign({
      path: "M ".concat(arrowSize, ",").concat(arrowSize, " L -").concat(arrowSize, ",0 L ").concat(arrowSize, ",-").concat(arrowSize, " L 0,0 Z"),
      anchor: '0.5 0.5',
      transformOrigin: 'center'
    }, arrowStyle)
  });
  return arrowMarker;
}
function getPath(points, coordinate) {
  if (!isPolar(coordinate)) return line().x(function (d) {
    return d[0];
  }).y(function (d) {
    return d[1];
  })(points);
  var center = coordinate.getCenter();
  return arc()({
    startAngle: 0,
    endAngle: Math.PI * 2,
    outerRadius: dist(points[0], center),
    innerRadius: dist(points[1], center)
  });
}
function getTransform(coordinate, transform) {
  if (!isPolar(coordinate)) return transform;
  var _coordinate$getCenter = coordinate.getCenter(),
    _coordinate$getCenter2 = _slicedToArray(_coordinate$getCenter, 2),
    cx = _coordinate$getCenter2[0],
    cy = _coordinate$getCenter2[1];
  return "translate(".concat(cx, ", ").concat(cy, ") ").concat(transform || '');
}
export var Line = function Line(options, context) {
  var arrow = options.arrow,
    _options$arrowSize = options.arrowSize,
    arrowSize = _options$arrowSize === void 0 ? 4 : _options$arrowSize,
    style = __rest(options, ["arrow", "arrowSize"]);
  var coordinate = context.coordinate,
    document = context.document;
  return function (points, value, defaults) {
    var defaultColor = defaults.color,
      lineWidth = defaults.lineWidth,
      shapeTheme = __rest(defaults, ["color", "lineWidth"]);
    var _value$color = value.color,
      color = _value$color === void 0 ? defaultColor : _value$color,
      _value$size = value.size,
      size = _value$size === void 0 ? lineWidth : _value$size;
    var arrowMarker = arrow ? getArrowMarker(document, arrowSize, Object.assign({
      fill: style.stroke || color,
      stroke: style.stroke || color
    }, subObject(style, 'arrow'))) : null;
    var path = getPath(points, coordinate);
    var transform = getTransform(coordinate, value.transform);
    return select(document.createElement('path', {})).call(applyStyle, shapeTheme).style('d', path).style('stroke', color).style('lineWidth', size).style('transform', transform).style('markerEnd', arrowMarker).call(applyStyle, style).node();
  };
};
Line.props = {
  defaultMarker: 'line',
  defaultEnterAnimation: 'fadeIn',
  defaultUpdateAnimation: 'morphing',
  defaultExitAnimation: 'fadeOut'
};